/*
  Waldo override for the "Related Products" carousel (Slick, initialised by
  shopbe.min.js after its AJAX fetch of /recommendations/products).
  We don't touch the vendored shopbe.min.js — instead we replace the relevant
  init function(s) before they ever run, with the same logic but our own
  column counts: 3 on mobile, 5 on desktop.

  NOTE 1: the global object is window.shopee (not window.shopbe) — that's how
  it's actually named in the minified shopbe.min.js that ships to production,
  despite the unminified source (shopbe.js, unused — see footer_scripts.liquid)
  calling it "shopbe". Cost us a broken first attempt.

  NOTE 2: which init function actually runs depends on the "Related Products"
  section's "style_recommendations" setting (config/settings_data.json):
    - 'style_default' -> data-recommendations-grid -> initSliderRecommendations
    - 'style_custom'  -> data-related-products      -> initRelatedPrSt2Slider
  Live setting is currently 'style_custom', so initRelatedPrSt2Slider is the
  one that matters — but we override both so this keeps working if the
  setting is ever switched back.

  Must load AFTER shopbe.min.js and BEFORE its AJAX response arrives (always
  true in practice — this file executes synchronously on page load, the AJAX
  call resolves later).
*/
(function () {
  if (!window.shopee) { return; }

  var nextArrow = '<button type="button" class="slick-next"><svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" id="Layer_1" x="0px" y="0px" viewBox="0 0 17 33" xml:space="preserve"><g id="e4eb89a6-f885-43b8-9259-0d6b1516fab0"><g id="_x38_e584754-6657-46f1-a9d8-2cfd6623b552"><g><polygon points="14.9,14.5 0,0 0,3.7 11.1,14.5 13.2,16.5 11.1,18.5 0,29.3 0,33 14.9,18.5 17,16.5 "></polygon></g></g></g></svg></button>';
  var prevArrow = '<button type="button" class="slick-prev"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 17 33"><g id="7f9a1925-e8c7-4614-8787-3c6095a9f6e1" data-name="Layer 2"><g id="c9b7920a-81fa-4bfe-ad13-4da717c6854b" data-name="Layer 1"><g id="c2d982ff-0cf6-4220-b365-47f30d708fea" data-name="e4eb89a6-f885-43b8-9259-0d6b1516fab0"><g id="f51d455e-6b9c-4c4e-96db-a5004582beda" data-name="8e584754-6657-46f1-a9d8-2cfd6623b552"><polygon points="0 16.5 2.1 18.5 17 33 17 29.3 5.9 18.5 3.8 16.5 5.9 14.5 17 3.7 17 0 2.1 14.5 0 16.5"></polygon></g></g></g></g></svg></button>';

  var slickConfig = {
    slidesToShow: 5,
    slidesToScroll: 1,
    dots: true,
    speed: 800,
    autoplay: false,
    infinite: false,
    rows: 1,
    nextArrow: nextArrow,
    prevArrow: prevArrow,
    responsive: [
      {
        breakpoint: 991,
        settings: {
          slidesToScroll: 1,
          slidesToShow: 3,
          rows: 1,
          arrows: false
        }
      }
    ]
  };

  window.shopee.initSliderRecommendations = function () {
    var DataRecommendations = jQuery('[data-recommendations-grid]'),
        productGrid = DataRecommendations.find('.products-grid');

    productGrid.each(function () {
      var self = jQuery(this);
      if (self.not('.slick-initialized')) {
        self.slick(slickConfig);
      }
    });
  };

  window.shopee.initRelatedPrSt2Slider = function () {
    var relatedSlider = jQuery('[data-related-products]'),
        productGrid = relatedSlider.find('.products-grid');

    productGrid.each(function () {
      var self = jQuery(this);
      if (self.not('.slick-initialized')) {
        self.slick(slickConfig);
      }
    });
  };
})();
